import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: 'https://select.robot-by.com', // 基础URL
  timeout: 10000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // 直接返回响应数据
    return response.data
  },
  error => {
    console.error('响应错误:', error)
    // 可以在这里统一处理错误，如401跳转登录页等
    return Promise.reject(error)
  }
)

export default service
